import { useState } from "react";
import { isSoundEnabled, setSoundEnabled } from "../lib/sound";

export default function SoundToggle({ className = "" }: { className?: string }) {
  const [on, setOn] = useState(isSoundEnabled());
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={on ? "Mute sound" : "Unmute sound"}
      onClick={() => {
        const next = !on;
        setOn(next);
        setSoundEnabled(next);
      }}
      className={`icon-btn ${className}`}
      title={on ? "Sound on" : "Sound off"}
    >
      <span aria-hidden>{on ? "🔊" : "🔇"}</span>
      <span className="sr-only">{on ? "Sound on" : "Sound off"}</span>
    </button>
  );
}
